import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { BONUSES, PRICE } from '../constants/content';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  return <section className="w-full bg-ink py-14 text-white sm:py-20" data-id="element-17">
      <div className="mx-auto max-w-3xl px-4" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-12 text-center" data-id="element-19">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border-2 border-gold bg-gold/10 px-4 py-1.5 text-sm font-700 uppercase tracking-widest text-gold-light" data-id="element-20">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" />
            Bonos exclusivos
          </div>
          <h2 className="font-display text-3xl font-700 leading-tight sm:text-5xl" data-id="element-22">
            Reclamá Estos 8 Bonos Exclusivos Si Comprás Hoy
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-gray-300" data-id="element-23">
            Si entrás hoy, te llevás 8 bonos especiales por tiempo limitado que
            te van a hacer arrancar mucho más rápido…
          </p>
        </motion.div>

        {/* Vertical bonus stack */}
        <div className="space-y-6" data-id="element-24">
          {BONUSES.map((b, i) => <motion.article key={b.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.05
        }} className="flex flex-col gap-5 rounded-2xl border-2 border-gold bg-gradient-to-b from-white to-cream p-5 text-ink shadow-[0_0_40px_-12px_rgba(200,150,30,0.5)] sm:flex-row sm:items-center sm:p-6" data-id="element-25">
              <div className="relative shrink-0 self-center" data-id="element-26">
                <img src={b.img} alt={b.title} width={128} height={128} loading="lazy" decoding="async" onError={e => {
              const img = e.currentTarget;
              // Fallback to a verified poultry photo so no broken image shows.
              if (!img.dataset.fallback) {
                img.dataset.fallback = 'true';
                img.src = 'https://images.unsplash.com/photo-1604503468506-a8da13d82791?auto=format&fit=crop&w=500&q=80';
              }
            }} className="h-32 w-32 rounded-xl object-cover ring-4 ring-gold/40 sm:h-28 sm:w-28" data-id="element-27" />
                <span className="absolute -left-3 -top-3 flex h-10 w-10 items-center justify-center rounded-full bg-crimson font-display text-lg font-700 text-white shadow-md" data-id="element-28">
                  #{b.n}
                </span>
              </div>
              <div className="flex-1 text-center sm:text-left" data-id="element-29">
                <span className="text-xs font-700 uppercase tracking-widest text-gold-dark" data-id="element-30">
                  Bono #{b.n}
                </span>
                <h3 className="mb-1 font-display text-xl font-600 sm:text-2xl" data-id="element-31">
                  {b.title}
                </h3>
                <p className="mb-3 text-sm leading-relaxed text-gray-700" data-id="element-32">
                  {b.desc}
                </p>
                <div className="inline-flex items-center gap-2 rounded-lg bg-green-100 px-3 py-1.5 text-sm font-700 text-green-800" data-id="element-33">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" />
                  Valor Regular:{' '}
                  <PriceDisplay amount={b.value} strike className="text-green-700" data-id="element-35" />
                  <span data-id="element-36">— GRATIS para vos</span>
                </div>
              </div>
            </motion.article>)}
        </div>

        {/* Total value box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 rounded-2xl border-4 border-gold bg-crimson-dark p-6 text-center shadow-xl sm:p-8" data-id="element-37">
          <p className="text-sm font-600 uppercase tracking-widest text-gold-light" data-id="element-38">
            Valor total de todo el paquete
          </p>
          <div className="mt-2 flex flex-col items-center justify-center gap-1" data-id="element-39">
            <PriceDisplay amount={PRICE.totalValue} strike className="font-display text-3xl font-600 text-gray-300 sm:text-4xl" data-id="element-40" />
            <span className="text-base font-600 text-white" data-id="element-41">
              Hoy, tu inversión es solo de
            </span>
            <PriceDisplay amount={PRICE.today} className="font-display text-5xl font-700 text-gold-light sm:text-6xl" symbolClassName="mr-0.5 align-top text-3xl" data-id="element-42" />
          </div>
        </motion.div>
      </div>
    </section>;
}